const config = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  
  apiUrl: process.env.REACT_APP_API_URL,
  seedRoundApiUrl: process.env.REACT_APP_SEED_ROUND_API_URL,

};
export default config;
